import { lazier } from '@shared/components';

export const ServiceModal = lazier(() => import('./ServiceModal'), false);
export { default as ServiceHoursButton } from './ServiceHoursButton';
export { default as ServiceProjectButton } from './ServiceProjectButton';
export { default as EditServiceButton } from './EditServiceButton';
